var map = {
	"./8SeaterminiBus.svg": 424,
	"./Estate.svg": 3175,
	"./EstateCar.svg": 3971,
	"./Executive.svg": 4627,
	"./ExecutiveCar.svg": 951,
	"./ExecutivePeopleCarrier.svg": 1134,
	"./PeopleCarrier.svg": 8082,
	"./Saloon.svg": 6347,
	"./saloonCar.svg": 9007
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8739;